<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main" v-if="!empty">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>设备管理</span>
          <el-button v-if="multipleSelection.length == 0" style="float: right;" type="primary" @click="addBtn">创建
          </el-button>
          <el-button v-has="'equipmentManagement:batchImport'" type="success" style="float: right;margin-right:20px"
            @click="onimport">批量导入</el-button>
          <el-button v-has="'equipmentManagement:export'" type="primary" style="float: right;margin-right:20px"
            @click="exportExcel">导出</el-button>
          <el-button v-has="'equipmentManagement:synchronousTask'"
            v-if="multipleSelection.length == 0&&(commuType==1||commuType==3)" type="primary"
            style="float: right;margin-right:10px" @click="synchronousTask">同步采集任务</el-button>
          <div style="float: right;" v-if="multipleSelection.length != 0">
            <span>已选中<i class="checkedNumb"> {{ multipleSelection.length }}</i>
              个</span>
            <el-dropdown trigger="click" @command="operationBtn">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{type:'del',para:multipleSelection}">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </div>
      </div>
      <div class="coreMain">
        <el-row :gutter="20" class="coreMainRow" style="margin-bottom: 10px;">
          <el-col :span="8">
            <div class="bg-white coreMainRowNumb">
              <span>设备总数</span>
              {{statistics.total}}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="bg-white coreMainRowNumb">
              <span>在线</span>
              <b style="color: green;">{{statistics.online}}</b>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="bg-white coreMainRowNumb">
              <span>离线</span>
              {{statistics.offline}}
            </div>
          </el-col>
        </el-row>
        <div>
          <el-input class="input-with-select" placeholder="搜索设备名称/编号/网关编号" v-model="search"
            @keyup.enter.native="searchBtn" maxlength="500">
          </el-input>
          <el-select v-model="status" clearable placeholder="状态" @change="changeStatus">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-cascader placeholder="设备分类" :options="deviceClassList" v-model="categoryId" clearable filterable
            change-on-select @change="changeCategory"></el-cascader>
          <el-cascader placeholder="品牌/型号" :options="modelList" v-model="model" clearable filterable change-on-select
            @change="changeModel"></el-cascader>
          <el-button @click="searchBtn" slot="append" icon="el-icon-search" type="primary"></el-button>
          <el-button class="clearSearch" type="text" @click="reset">清除搜索条件</el-button>
        </div>
        <el-table v-loading="loading" ref="multipleTable" :data="tableData" style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="名称" min-width="180px">
            <template slot-scope="scope">
              <el-link :underline="false" class="tableButton" type="primary" @click="detailBtn(scope.row.id)">
                {{ scope.row.name }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="code" label="编号" min-width="170px"></el-table-column>
          <el-table-column prop="onlineStatus" label="在线状态">
            <template slot-scope="scope">
              <span v-if="scope.row.onlineStatus==0"> <i class="redDot"></i>离线</span>
              <span v-else-if="scope.row.onlineStatus==1"> <i class="greenDot"></i>在线</span>
              <span v-else>---</span>
            </template>
          </el-table-column>
          <el-table-column prop="devProtocolName" min-width="120px" label="设备协议">
            <template slot-scope="scope">
              <el-link :underline="false" class="tableButton" type="primary"
                @click="toDevProtocolPage(scope.row.devProtocolId)">
                {{ scope.row.devProtocolName }}</el-link>
            </template>
          </el-table-column>

          <el-table-column prop="moduleCode" min-width="150px" label="网关编号">
            <template slot-scope="scope">
              <el-link :underline="false" class="tableButton" type="primary" @click="toModulePage(scope.row.moduleId)">
                {{scope.row.moduleCode}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="categoryFullName" label="设备分类"></el-table-column>
          <!-- <el-table-column prop="modelName" label="型号"></el-table-column>
          <el-table-column prop="brandName" label="品牌"></el-table-column> -->
          <el-table-column prop="lastUpDate" label="最新上报时间" :formatter="dateFormat" min-width="140px">
          </el-table-column>
          <el-table-column prop="createDate" label="创建时间" :formatter="dateFormat" min-width="140px">
          </el-table-column>
          <el-table-column prop="" label="" width="190px">
            <template slot-scope="scope">
              <el-link type="primary" icon="el-icon-view" @click="viewData(scope.row)">数据</el-link>
              <el-link style="margin: 0px 10px;" type="primary" icon="el-icon-s-promotion"
                @click="deviceCtrl(scope.row)">
                控制</el-link>

              <el-dropdown @command="command">
                <span style="color:#409EFF;font-size: 14px;cursor:pointer;" class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ type: 'edit', row: scope.row }">编辑</el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.categoryFullId == '08389ce682e949a6a77aee46c02aa3f6,05e54a60e4ab4d48b416f46e0bc12ebe'"
                    :command="{ type: 'viewVideo', row: scope.row }">查看视频</el-dropdown-item>
                  <el-dropdown-item :command="{ type: 'del', row: scope.row }">删除</el-dropdown-item>
                  <el-dropdown-item :command="{ type: 'onlineDetail', onlineDetailDev: scope.row }">
                    在线情况
                  </el-dropdown-item>
                  <el-dropdown-item :command="{ type: 'instruction', row: scope.row }">
                    历史下发指令
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>


            </template>
          </el-table-column>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 没有网关显示的内容 -->
    <div class="emptyMain" v-if="empty">
      <el-card class="box-card">
        <img src="../../assets/images/shebeileijiankongdian.png" alt="" />
        <p>您还没有创建任何设备</p>
        <br />
        <el-button>了解详情</el-button>
        <el-button type="primary" @click="addBtn">创建设备</el-button>
        <el-button type="success" @click="onimport">批量导入</el-button>
      </el-card>
    </div>
    <el-dialog :title="vedeoTitle" :visible.sync="maskVisible" width="50%">
      <div id="video"></div>
    </el-dialog>

    <el-dialog :title="'设备（'+onlineDetailDev.name+'）在线情况'" :visible.sync="onlineDialog" :close-on-click-modal="false"
      :show-close="false">
      <div>
        <div style="text-align: right">
          <el-date-picker v-model="onlineTime" type="daterange" range-separator="-" start-placeholder="开始日期"
            end-placeholder="结束日期" :picker-options="pickerOptions" @change="getOnlineDetailData">
          </el-date-picker>
          <el-button type="primary" @click="getOnlineDetailData">搜索</el-button>
        </div>
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="dev-onOrOffline-dev">
              <el-timeline>
                <el-timeline-item :class="[state.textClass,state.lineClass]"
                  v-for="(state, index) in onlineData.timeline" :key="index" :icon="index==0?'el-icon-arrow-up':''"
                  :type="state.type" :hide-timestamp="index==0" :timestamp="state.createDate">
                  <span>{{state.text}}</span>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-col>
          <el-col :span="18">
            <div id="deviceSingleOnline" style="width: 100%;height: 300px"></div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onlineDialog = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 删除结果弹出框 -->
    <el-dialog :title="'删除结果'" :visible.sync="delErrorMsgMaskVisible" width="30%" :close-on-click-modal="false">
      <el-table ref="multipleTable" :data="delErrorMsgTableData" :border="true">
        <el-table-column prop="code" label="编号" align="center"></el-table-column>
        <el-table-column prop="errorMsg" label="错误信息">
          <template slot-scope="scope">
            <span style="color: #ff0000;">{{ scope.row.errorMsg }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delErrorMsgResultOff">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量导入" :visible.sync="batchImportDialog" width="30%" :close-on-click-modal="false">
      下载模板：<a href="./static/template/deviceTemplate.xls">模板</a>
      <el-form ref="uploadForm" :model="uploadForm">
        <el-form-item label="文件上传：" prop="attachmentId"><br />
          <el-upload :action="upload" :data="tokenData" ref="uploadRef" class="upload-demo" :auto-upload="false" drag
            :on-success="successHandle" :limit="1" accept=".xls,.xlsx,application/vnd.ms-excel" :with-credentials='true'
            :headers="myHeaders" :file-list="fileList" :on-change="uploadCharge" :on-remove="removeUpload">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="设备协议：" prop="devProtocolId"><br />
          <div>
            <el-select v-model="uploadForm.devProtocolId" filterable placeholder="未选择">
              <el-option v-for="item in devProtocolList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="importExcel">开始导入</el-button>
        <el-button type="primary" @click="closeBatchImportDialog">关 闭</el-button>
      </span>
    </el-dialog>
    <!--设备控制弹窗-->
    <el-dialog class="no-padding-dialog" title="设备控制" :visible.sync="showDeviceCtrl" v-if="showDeviceCtrl" width="80%"
      :close-on-click-modal="false" top="5vh">
      <div slot="title" style="height:86px;background-color:#072f52;color:white;padding:18px;">
        <h2 style="margin-bottom: 12px">{{ ctrlDeviceData.name }}</h2>
        <h4>
          <span v-if="ctrlDeviceData.onlineStatus == 1"><i class="greenDot"></i>在线</span>
          <span v-else><i class="redDot"></i>离线</span>
        </h4>
      </div>
      <div style="height:650px;padding: 0 20px">
        <el-row :gutter="120" style="margin-top:20px;">
          <el-col :span="12" style="height:600px" class="hidden-scroll-bar">
            <remote-control :deviceId="ctrlDeviceData.id" :deviceCode="ctrlDeviceData.code"></remote-control>
          </el-col>
          <el-col :span="12" style="height:600px" class="hidden-scroll-bar">
            <device-data-show :deviceId="ctrlDeviceData.id"></device-data-show>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showDeviceCtrl=false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 下发指令列表 -->
    <equipmentInstruction ref="equipmentInstruction" />
  </div>
</template>
<style>
  #video {
    height: 500px;
  }
</style>

<script>
  // 引入基本模板
  let echarts = require("echarts/lib/echarts");
  // 引入折线图组件
  require("echarts/lib/chart/line");
  // 引入提示框和title组件
  require("echarts/lib/component/tooltip");
  require("echarts/lib/component/title");
  require("echarts/lib/component/legend");
  import API from "../../api/api";
  import dayjs from "dayjs"
  import equipmentInstruction from './equipmentInstruction.vue'
  const ckplayer = require("../../../static/ckplayer.js");
  import remoteControl from '@/components/device/remoteControl.vue' //引入远程控制子组件
  import deviceDataShow from '@/components/device/deviceDataShow.vue' //引入远程控制子组件

  export default {
    components: {
      equipmentInstruction,
      remoteControl,
      deviceDataShow
    },
    data() {
      return {
        activeNames: '',
        delErrorMsgMaskVisible: false,
        delErrorMsgTableData: [],
        vedeoTitle: '',
        maskVisible: false,
        commuType: sessionStorage.getItem('commuType'),
        vedeoUrl: '',
        empty: false, //控制数据为空展示空页面
        total: 0,
        pageSize: 10,
        currentPage: 1,
        statistics: {},
        loading: false, //加载条
        search: "", //搜索
        status: "", //状态
        model: [], //品牌型号
        categoryId: [], //设备分类
        deviceClassList: [], //设备分类下拉数据
        modelList: [], //品牌型号下拉数据
        statusList: [ //状态下拉数据
          {
            value: 1,
            label: "在线"
          },
          {
            value: 0,
            label: "离线"
          }
        ],
        tableData: [],
        multipleSelection: [],
        onlineDialog: false, //展示网关在线情况模态框
        onlineDetailDev: {}, //展示在线情况网关
        onlineData: {}, //单个设备在线率echart数据
        pickerOptions: { //时间选择器
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        onlineTime: [(new Date()).getTime() - 3600 * 1000 * 24 * 1, new Date()],
        batchImportDialog: false,
        upload: API.uploadDeviceFile(), //上传地址
        myHeaders: {
          Authentication: this.$cookies.get('token')
        },
        uploadForm: {
          devProtocolId: ''
        },
        devProtocolList: [],
        fileList: [],
        fileCount: 0,
        localParams: {
          search: '',
          status: '',
          model: [],
          categoryId: []
        },
        showDeviceCtrl: false, //是否显示设备控制弹窗
        ctrlDeviceData: {}, //当前控制设备数据
      };
    },
    computed: {
      tokenData: function () {
        return {
          devProtocolId: this.uploadForm.devProtocolId,
          access_token: this.$cookies.get('access_token'),
          commuType: this.commuType
        }
      }
    },
    created() {
      let search = JSON.parse(localStorage.getItem('localParams'));
      if (search) {
        this.search = search.search
        this.status = search.status
        this.model = search.model
        this.categoryId = search.categoryId

      }
    },
    methods: {

      uploadCharge(file, fileList) {
        this.fileCount = fileList.length
      },

      //查询设备协议下拉数据
      getProtocolList() {
        let param = {
          commuType: sessionStorage.getItem('commuType')
        };
        API.platformDevDeviceProtocol(param).then(res => {
          if (res.code == 1) {
            this.devProtocolList = res.data;
          }
        });
      },

      successHandle(data) {
        if (data.data == null) {
          this.$message.error(data.msg);
          return
        }

        let errCount = data.data.errCount
        let succCount = data.data.succCount
        let errList = data.data.errList
        this.$alert('成功：<strong style="color:green">' + succCount + '</strong>条<br>失败：<strong style="color:red">' +
          errCount +
          '</strong>条<br>失败记录：<br>' +
          errList.join("<br>"), '导入结果', {
          dangerouslyUseHTMLString: true
        });
      },

      removeUpload(file, fileList) {
        this.fileCount = fileList.length
      },

      importExcel() {
        if (this.fileCount == 0) {
          this.$message.warning('请选择文件')
          return false
        }
        this.$refs.uploadRef.submit();
      },

      onimport() {
        this.batchImportDialog = true
        this.getProtocolList()
      },

      closeBatchImportDialog() {
        this.batchImportDialog = false
        this.uploadForm.devProtocolId = ''
        this.fileList = []
      },

      exportExcel() {
        let para = {
          commuType: this.commuType,
          code: this.search, //搜索栏
          onlineStatus: this.status, //状态搜索
          brand: this.model[0] ? this.model[0] : '', //品牌搜索
          model: this.model[1] ? this.model[1] : '', //型号搜索
          categoryId: this.categoryId ? this.categoryId.join(',') : null, //设备分类
          pageSize: 10000000,
          access_token: this.$cookies.get('access_token') ? this.$cookies.get('access_token') : ''
        };
        window.open(API.exportDeviceUrl(para))
      },

      toDevProtocolPage(devProtocolId) {
        this.$router.push({
          path: "/equipment/equimentProtocolDetails",
          query: {
            id: devProtocolId
          }
        });
      },

      // 跳转到网关详情
      toModulePage(moduleId) {
        this.$router.push({
          path: "/device/moduleDetail",
          query: {
            id: moduleId
          }
        });
      },

      dateFormat(row, column, cellValue, index) {
        if (row[column.property]) {
          return dayjs(new Date(row[column.property])).format("YYYY-MM-DD HH:mm:ss")
        } else {
          return '--'
        }
      },
      init() {
        //获取列表数据
        let para = {
          commuType: this.commuType,
          pageSize: this.pageSize,
          currentPage: this.currentPage
        };
        this.loading = true; /*显示加载条*/
        this.getpageList()
        //获取设备统计信息
        //获取列表数据
        let StatisticsPara = {
          commuType: this.commuType,
        };
        API.platformDevDeviceStatistics(StatisticsPara).then(res => {
          if (res.code == 1) {
            this.statistics = res.data
          }
        });
        //获取设备分类树形数据
        API.platformDevCategoryDevCategoryList().then(res => {
          if (res.code == 1) {
            this.deviceClassList = res.data.devCategoryTreeList
          }
        })
        //品牌型号级联数据
        API.platformDevProtocolBrandAndModel().then(res => {
          if (res.code == 1) {
            this.modelList = res.data.brandAndModel
          }
        })
        //先渲染一遍播放器资源
        var videoObject = {
          container: '#video', //容器的ID或className
          variable: 'player', //播放函数名称
          autoplay: false,
          live: true,
          video: '',
        };
        var player = new ckplayer.ckplayer(videoObject);
      },
      //获取列表复用
      getpageList() {
        let para = {
          commuType: this.commuType,
          code: this.search, //搜索栏
          onlineStatus: this.status, //状态搜索
          brand: this.model[0] ? this.model[0] : '', //品牌搜索
          model: this.model[1] ? this.model[1] : '', //型号搜索
          categoryId: this.categoryId ? this.categoryId.join(',') : null, //设备分类
          pageSize: this.pageSize,
          currentPage: this.currentPage
        };
        this.loading = true; /*显示加载条*/
        API.platformDevDevicePage(para)
          .then(res => {
            if (res.code == 1) {
              this.tableData = res.data.resultPage;
              this.total = res.data.total;
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false; /*显示加载条*/
          })
      },
      //输入搜索功能
      searchBtn() {
        // this.status = ''
        // this.model = []
        // this.categoryId = []
        this.currentPage = 1
        this.getpageList()
        this.localParams.search = this.search

        localStorage.setItem('localParams', JSON.stringify(this.localParams));
      },
      //品牌型号下拉搜索
      changeModel() {
        // this.search = ""
        // this.categoryId = []
        // this.status = ''
        this.localParams.model = this.model
        console.log(this.localParams)
        this.currentPage = 1
        localStorage.setItem('localParams', JSON.stringify(this.localParams));
        this.getpageList()
      },
      changeCategory(val) {
        // this.search = ""
        // this.status = ''
        // this.model = []
        this.localParams.categoryId = this.categoryId ? this.categoryId.join(',') : null,
          this.currentPage = 1
        localStorage.setItem('localParams', JSON.stringify(this.localParams));
        this.getpageList()
      },
      //状态下拉搜索
      changeStatus() {
        // this.search = ""
        // this.categoryId = []
        // this.model = []
        this.localParams.status = this.status
        // console.log(this.localParams)
        localStorage.setItem('localParams', JSON.stringify(this.localParams));
        this.currentPage = 1
        this.getpageList()
      },
      //清除搜索条件
      reset() {
        this.search = "";
        this.status = "";
        this.categoryId = []
        this.model = []
        this.currentPage = 1
        localStorage.removeItem('localParams');
        this.getpageList()
      },
      //选中的数组
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //批量操作-删除
      operationBtn(val) {
        if (val.type == 'del') {
          let arr = []
          val.para.forEach(element => {
            arr.push(element.id)
          });
          let str = arr.join(',')
          this.delBtn(str)
        }
      },
      //单独删除
      command(val) {
        if (val.type == 'del') {
          let str = val.row.id
          this.delBtn(str)
        }
        if (val.type == 'viewVideo') {
          let str = val.row.id
          this.vedeoTitle = val.row.code
          this.getYSPlayUrl(str)
          this.maskVisible = true;
        }
        if (val.type == 'edit') {
          this.$router.push({
            path: "/equipment/equipmentAdd",
            query: {
              id: val.row.id,
              flag: 'edit'
            }
          });
        }
        if (val.type == 'onlineDetail') {
          this.onlineDetailDev = val.onlineDetailDev;
          this.onlineTime = [(new Date()).getTime() - 3600 * 1000 * 24 * 1, new Date()]
          this.onlineDialog = true;
          this.getOnlineDetailData()
        }
        if (val.type == 'instruction') {
          this.$refs.equipmentInstruction.show(val.row)
        }
      },
      //删除功能 单独批量公用
      getYSPlayUrl(devId) {
        let para = {
          devId: devId
        }
        API.getYSPlayUrl(para).then(res => {
          if (res.code == 1) {
            var vedeoUrl = res.data;
            this.vedeoUrl = vedeoUrl;
            var videoObject = {
              container: '#video', //容器的ID或className
              variable: 'player', //播放函数名称
              autoplay: false,
              live: true,
              video: vedeoUrl,
            };
            var player = new ckplayer.ckplayer(videoObject);
          } else {
            this.$message.error('获取播放地址失败！');
          }
        })
      },
      //删除功能 单独批量公用
      delBtn(delID) {
        let para = {
          ids: delID
        }
        this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          API.delPlatformDevDevice(para).then(res => {
            if (res.code == 1) {
              this.$message.success('删除成功');
              this.getpageList();
            } else {
              if (!res.data) {
                this.$message.error(res.msg);
                return;
              }
              var falseList = res.data;
              this.delErrorMsgTableData = [];
              this.tableData.forEach(item => {
                falseList.forEach(errMsg => {
                  if (errMsg.indexOf(item.id) != -1) {
                    this.delErrorMsgTableData.push({
                      code: item.code,
                      errorMsg: errMsg.substring(errMsg.indexOf('删除失败'))
                    })
                    return;
                  }
                })
              });
              this.delErrorMsgMaskVisible = true;
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //关闭删除结果
      delErrorMsgResultOff() {
        this.delErrorMsgMaskVisible = false;
        this.getpageList();
      },
      //跳转到详情页
      detailBtn(id) {
        //  直接调用$router.push 实现携带参数的跳转
        this.$router.push({
          path: "/equipment/equipmentDetail",
          query: {
            id: id
          }
        });
      },
      //跳转创建网关页
      addBtn() {
        this.$router.push({
          path: "/equipment/equipmentAdd"
        });
      },
      viewData(row) {
        this.$router.push({
          path: "/equipment/equipmentViewData",
          query: {
            id: row.id,
            name: row.name
          }
        });
      },
      //设备控制按钮触发
      deviceCtrl(row) {
        this.showDeviceCtrl = true //显示设备控制弹窗
        this.ctrlDeviceData = row //将该行数据赋予控制设备数据
      },
      synchronousTask() {
        let para = {
          commuType: this.commuType,
          code: this.search, //搜索栏
          onlineStatus: this.status, //状态搜索
          brand: this.model[0] ? this.model[0] : '', //品牌搜索
          model: this.model[1] ? this.model[1] : '', //型号搜索
          categoryId: this.categoryId ? this.categoryId.join(',') : null, //设备分类
          access_token: this.$cookies.get('access_token') ? this.$cookies.get('access_token') : ''
        };
        API.synchronousTask(para)
          .then(res => {
            if (res.code == 1) {
              console.log(res.data);
              if (res.data.totalNum == res.data.successNum) {
                this.$message.success('同步成功');
              } else {
                this.$message.warning("同步成功" + res.data.successNum + '条,失败' + (res.data.totalNum - res.data
                  .successNum) + '条.');
              }
            } else {
              this.$message.error("同步失败！");
            }
          })

      },
      //获取在线情况数据
      getOnlineDetailData() {
        if (!this.onlineDetailDev.id || this.onlineTime.length < 2) {
          return false;
        }
        let para = {
          deviceId: this.onlineDetailDev.id,
          startDateStr: dayjs(this.onlineTime[0]).format("YYYY-MM-DD 00:00:00"),
          endDateStr: dayjs(this.onlineTime[1]).format("YYYY-MM-DD 23:59:59"),
        };
        this.onlineData = {};
        API.DashboardOnlineDetail(para)
          .then(res => {

            if (res.code == 1) {
              this.onlineData = res.data
              this.onlineData.timeline = this.formatTimelineData(this.onlineData.deviceOnlineRecords)
              this.deviceSingleOnline();
            } else {
              this.$message.error(res.msg);
            }
          })

      },
      /**单个设备在线情况echart图**/
      deviceSingleOnline() {
        // 基于准备好的dom，初始化echarts实例
        let deviceSingleOnline = echarts.init(
          document.getElementById("deviceSingleOnline")
        );
        var data = this.onlineData;
        var devData = [];
        for (let n = 0; n < data.deviceOnlineRecords.length; n++) {
          devData.push([data.deviceOnlineRecords[n].createDate, data.deviceOnlineRecords[n].deviceStatus])
        }
        deviceSingleOnline.setOption({
          color: ["#2C89F6", "#FF8B9F"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "line" // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function (params) {
              var res = ''
              for (var i = 0; i < params.length; i++) {
                res += '<p>' + params[i].seriesName + ':  ' + dayjs(new Date(params[i].value[0])).format(
                  'YYYY-MM-DD HH:mm') + ',' + (params[i].data[1] == 1 ? "在线" : "离线") + '</p>'
              }
              return res;
            },
          },
          legend: {
            data: [data.deviceName + '（' + data.deviceCode + '）'],
            x: "60px"
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "time",
            boundaryGap: false,
            name: "时间",
            splitLine: {
              show: false
            },
          },
          yAxis: {
            type: "value",
            boundaryGap: false,
            min: 0,
            max: 1,
            minInterval: 1,
            axisLabel: {
              formatter: function (value) {
                var texts = [];
                if (value == 0) {
                  texts.push('离线');
                } else if (value == 1) {
                  texts.push('在线');
                }
                return texts;

              }
            }
          },
          series: [{
            name: data.deviceName + '（设备）',
            type: "line",
            step: 'end',
            label: {
              normal: {
                show: false
              }
            },
            data: devData
          }],
          dataZoom: [{
            type: 'inside',
          }],

        });
        window.addEventListener("resize", function () {
          deviceSingleOnline.resize();
        });
      },
      //分页
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getpageList()
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getpageList()
      },
      /***格式化在线状态时间线数据****/
      formatTimelineData(arr) {
        let timelineData = []
        let nextState = 0
        let [onlineText, onlineLine, offlineText, offlineLine] = ['onlineText', 'onlineLine', 'offlineText', 'offlineLine']
        for (let i = 0; i < arr.length; i++) {
          let { deviceStatus, createDate } = arr[i];
          let text;
          if (i == 0) {
            text = (deviceStatus == 1 ? '设备在线状态' : '设备离线状态')
          } else {
            text = (i == arr.length - 1 ? (deviceStatus == 1 ? '当前设备状态-设备在线' : '当前设备状态-设备离线') : (deviceStatus == 1 ? '设备上线' : '设备离线'))
          }

          timelineData.unshift({
            deviceStatus: deviceStatus,
            createDate: dayjs(new Date(createDate)).format("YYYY-MM-DD HH:mm:ss"),
            textClass: deviceStatus == 1 ? onlineText : offlineText,
            lineClass: nextState == 1 ? onlineLine : offlineLine,
            type: deviceStatus == 1 ? 'success' : 'danger',
            text: text
          })
          nextState = deviceStatus
        }
        return timelineData;
      },
    },
    mounted() {

      this.init()
    }
  };

</script>


// WEBPACK FOOTER //
// src/views/platform/equipmentManagement.vue